import {ScreenDetectorListener} from './ScreenDetectorListener'

export class ScreenDetector {
    /**
     * @param {function} mobileViewDetectionCallback
     */
    constructor(mobileViewDetectionCallback) {
        this.mobileViewDetectionCallback = mobileViewDetectionCallback;

        this.listener = new ScreenDetectorListener(this);
    }

    /**
     * @returns {boolean}
     */
    isMobileView() {
        return this.mobileViewDetectionCallback();
    }
}